import React from "react";

const Team = ({ icon, label }) => (
  <>
    <img className="logo" src={icon} alt={label} />
  </>
);

export default Team;
